// TermInsuranceFormTranslations.js
const TermInsuranceFormTranslations = {
  en: {
    labels: {
      title: 'Term Insurance Requirement Analysis',
      description: 'Please fill in your details for Term Insurance requirement analysis.',
      form_timestamp: 'Timestamp',
      email: 'Email',
      form_language: 'Form Language',
      name: 'Full Name',
      mobile: 'Mobile Number',
      city_of_residence: 'City of Residence',
      city_of_residence_select: 'Select City',
      otherCity: 'Please specify your city',
      age: 'Age',
      desired_retirement_age: 'Desired Retirement Age',
      gender: 'Gender',
      dob:'Date of Birth',
      marital_status: 'Marital Status',
      sole_earning_member:'Are you the sole EARNING MEMBER of your Family?',
      spouse_age: 'What is the current age of your Spouse?',
      expected_life_expectancy_spouse: 'What is the expected life expectancy for which retirement funds would be needed for your Spouse in your absence?',
      number_of_dependents: 'Number of Dependents',
      current_annual_income: 'What is your Current Annual Income from all Sources? (e.g., 2500000)',
      current_monthly_household_expenses: 'What is your Current Monthly Household Expenses? (e.g., 100000)',
      existing_term_insurance_coverage: 'Do you have existing Term Insurance? If Yes, please specify your current coverage under all the policies held.',
      outstanding_lt_liabilities: 'Do you have any Long Term Liabilities such as Home Loan, Car Loan, Education Loan? If Yes, please specify the Total Outstanding Amount on all such liabilities. (Type 0 if none)',
      insurance_for_liabilities: 'Have you already taken insurance cover for these long term liabilities?',
      amount_of_cover_taken: 'If yes or partial cover, mention the amount of cover taken?',
      est_funds_for_lt_responsibilities: 'Are there any Long Term Responsibilities such as Child Education and/or Child Wedding? If Yes, please specify the Total Estimated funds required for all such responsibilities. (Type 0 if none)',
      investments_for_responsibilities: 'Have you Invested/Saved for these Responsibilities? If Yes, please specify the Total Estimated Value of such investments/Savings. (Type 0 if none)',
      pf_balance: 'In case you are a Salaried Employee, what is the current PF Balance? (Type 0 if not an Employee)',
      other_investments_ppf_nps: 'Have you invested in any other options like PPF, NPS, Mutual Funds, or Endowment Plans? If yes, what is the current estimated value of all such investments? (Type 0 if none)',
      submit: 'Submit',
      selectOption:'Select an option'
    },
    placeholders: {
      email: 'Enter your email address',
      name: 'Enter your full name',
      mobile: 'Enter your 10-digit mobile number',
      age: 'Your age will be calculated',
      city_of_residence:'-- Select City --',
      otherCity: 'Enter your city',
      dependents:'Select Number of Dependents',
      gender:'Select Gender',
      dob:'',
      age:'Your age will be calculated"',
      otherCity:'Enter your city',
      sole_earning_member:'Are you the sole EARNING MEMBER of your Family?',
      spouse_age: 'Enter age between 20 to 55',
      expected_life_expectancy_spouse:'Enter age between 60 to 90',
      current_annual_income: 'Enter annual income (min 500000)',
      current_monthly_household_expenses: 'Enter monthly expenses (min 10000)',
      existing_term_insurance_coverage: 'Do you have existing Term Insurance? If Yes, please specify your current coverage under all the policies held.',
      outstanding_lt_liabilities: 'Enter total estimated value (Type 0 if none)',
      insurance_for_liabilities: 'Select an Option',
      amount_of_cover_taken: 'Enter cover amount',
      est_funds_for_lt_responsibilities: 'Enter total estimated funds (Type 0 if none)',
      investments_for_responsibilities: 'Enter total estimated value (Type 0 if none)',
      pf_balance: 'Enter PF balance (Type 0 if not an Employee)',
      other_investments_ppf_nps: 'Enter total estimated value (Type 0 if none)',
      submit: 'Submit'
      


    },
    errors: {
      invalidMonthlyExpensesMax:"Annualized household expenses cannot exceed annual income.",
      invalidMonthlyExpensesMin:"Monthly household expenses must be at least 10000.",
      invalidAnnualIncome:"Annual income must be at least 500000.",
      invalidSpouseLifeExpectancy: "Spouse life expectancy must be between 60 and 90.",
      invalidSpouseAge : "Spouse age must be between 20 and 55.",
      emailRequired: 'Email is required.',
      emailInvalid: 'Invalid email format.',
      invalidEmail:"Please enter a valid email address.",
      invalidMobile:"Please enter a valid 10-digit mobile number starting with 6-9 without 4 identical digits consecutively.",
      languageRequired: 'Form language is required.',
      nameRequired: 'Name is required.',
      mobileRequired: 'Mobile number is required.',
      genderRequired: 'Gender is required.',
      dobRequired: 'Date of birth is required.',
      dateInvalid: 'Invalid date format.',
      cityRequired: 'City is required.',
      dependentsRequired: 'Number of dependents is required.',
      incomeRequired: 'Annual income is required.',
      expensesRequired: 'Monthly household expenses are required.',
      coverageRequired: 'Existing coverage is required.',
      liabilitiesRequired: 'Outstanding liabilities are required.',
      insuranceLiabilitiesRequired: 'Please indicate if insurance cover taken for liabilities.',
      coverAmountRequired: 'Cover amount is required when insurance is taken.',
      responsibilitiesRequired: 'Estimated funds for responsibilities are required.',
      investmentsRequired: 'Investments for responsibilities are required.',
      pfRequired: 'PF balance is required.',
      requiredCity: 'Please select your city of residence.',
      requiredOtherCity: 'Please specify your city.',
      submitError: 'Form submission failed.'
      
    },
    data: {

      
      soleEarnerOptions: [
        { value: 'Yes', label: 'Yes' },
        { value: 'No', label: 'No' }
      ],
      genderOptions: [
        { value: 'Male', label: 'Male' },
        { value: 'Female', label: 'Female' },
        { value: 'Other', label: 'Other' }
      ],
      maritalStatusOptions: [
        { value: 'unmarried', label: 'Unmarried' },
        { value: 'Married', label: 'Married' },
        { value: 'Divorced', label: 'Divorced' },
        { value: 'Widowed', label: 'Widowed' }
      ],
      cityOptions: [
        { value: 'Ahmedabad', label: 'Ahmedabad' },
        { value: 'Bengaluru', label: 'Bengaluru' },
        { value: 'Chennai', label: 'Chennai' },
        { value: 'Delhi', label: 'Delhi' },
        { value: 'Hyderabad', label: 'Hyderabad' },
        { value: 'Kolkata', label: 'Kolkata' },
        { value: 'Mumbai', label: 'Mumbai' },
        { value: 'Pune', label: 'Pune' },
        { value: 'Others', label: 'Others' },
      ],
      dependentsOptions: ['0','1','2','3','4','5','6'],
      termInsuranceCoverageOptions: ['0','5000000','10000000','15000000','20000000','30000000','other'],
      liabilitiesInsuranceCoverOptions: [
        { value: 'Yes', label: 'Yes' },
        { value: 'No', label: 'No' },
        { value: 'Partial', label: 'Partial Cover' }
      ]
    }
  },
  hi: {
    labels: {
      title: 'टर्म बीमा आवश्यकता विश्लेषण',
      description: 'कृपया टर्म बीमा आवश्यकता विश्लेषण के लिए अपने विवरण भरें।',
      title: 'टर्म इंश्योरेंस आवश्यकता विश्लेषण',
      description: 'टर्म इंश्योरेंस आवश्यकता विश्लेषण के लिए कृपया अपनी जानकारी भरें।',
      form_timestamp: 'समय मुहर',
      email: 'ईमेल',
      form_language: 'प्रपत्र भाषा',
      name: 'पूरा नाम',
      mobile: 'मोबाइल नंबर',
      city_of_residence: 'निवास शहर',
      city_of_residence_select: 'शहर चुनें',
      otherCity: 'कृपया अपना शहर बताएं',
      age: 'उम्र',
      desired_retirement_age: 'अपेक्षित सेवानिवृत्ति आयु',
      gender: 'लिंग',
      dob: 'जन्म तिथि',
      marital_status: 'वैवाहिक स्थिति',
      sole_earning_member: 'क्या आप अपने परिवार के एकमात्र आजीविका सदस्य हैं?',
      spouse_age: 'आपके जीवन साथी की वर्तमान आयु क्या है?',
      expected_life_expectancy_spouse: 'आपकी अनुपस्थिति में आपके जीवन साथी के लिए सेवानिवृत्ति निधि की आवश्यकता की अनुमानित आयु सीमा क्या है?',
      number_of_dependents: 'निर्भर व्यक्तियों की संख्या',
      current_annual_income: 'आपकी सभी स्रोतों से वर्तमान वार्षिक आय क्या है? (जैसे, 2500000)',
      current_monthly_household_expenses: 'आपका वर्तमान मासिक गृह खर्च कितना है? (जैसे, 100000)',
      existing_term_insurance_coverage: 'क्या आपके पास मौजूदा टर्म इंश्योरेंस है? यदि हाँ, तो सभी नीतियों के तहत आपकी कुल कवर राशि बताएं।',
      outstanding_lt_liabilities: 'क्या आपकी कोई दीर्घकालिक देनदारियां हैं जैसे होम लोन, कार लोन, एजुकेशन लोन? यदि हाँ, तो इन देनदारियों का कुल बकाया राशि बताएं। (यदि नहीं, तो 0 दर्ज करें)',
      insurance_for_liabilities: 'क्या आपने इन लंबी अवधि की देनदारियों के लिए बीमा करवाया हुआ है?',
      amount_of_cover_taken: 'यदि पूर्ण या आंशिक कवर है, तो कवर की राशि बताएं?',
      est_funds_for_lt_responsibilities: 'क्या कोई दीर्घकालिक जिम्मेदारियां हैं जैसे बच्चों की शिक्षा या विवाह? यदि हाँ, तो इन सभी जिम्मेदारियों के लिए अनुमानित कुल राशि बताएं। (यदि नहीं, तो 0 दर्ज करें)',
      investments_for_responsibilities: 'क्या आपने इन जिम्मेदारियों के लिए निवेश/बचत की है? यदि हाँ, तो उन निवेशों/बचतों का कुल अनुमानित मूल्य बताएं। (यदि नहीं, तो 0 दर्ज करें)',
      pf_balance: 'यदि आप वेतनभोगी कर्मचारी हैं, तो वर्तमान पीएफ बैलेंस क्या है? (यदि कर्मचारी नहीं हैं, तो 0 दर्ज करें)',
      other_investments_ppf_nps: 'क्या आपने किसी अन्य विकल्पों जैसे पीपीएफ, एनपीएस, म्यूचुअल फंड या एंडोमेंट प्लान में निवेश किया है? यदि हाँ, तो उनका वर्तमान अनुमानित मूल्य बताएं। (यदि नहीं, तो 0 दर्ज करें)',
      submit: 'जमा करें'
    
    },
    placeholders: {
        email: 'अपना ईमेल पता दर्ज करें',
        name: 'अपना पूरा नाम दर्ज करें',
        mobile: 'अपना 10 अंकों वाला मोबाइल नंबर दर्ज करें',
        age: 'आपकी उम्र स्वचालित रूप से गणना की जाएगी',
        dob: '',
        city_of_residence: '-- शहर चुनें --',
        otherCity: 'अपना शहर दर्ज करें',
        dependents: 'निर्भर व्यक्तियों की संख्या चुनें',
        gender: 'लिंग चुनें',
        sole_earning_member: 'क्या आप अपने परिवार के एकमात्र आजीविका सदस्य हैं?',
        spouse_age: '20 से 55 के बीच आयु दर्ज करें',
        expected_life_expectancy_spouse: '60 से 90 के बीच आयु दर्ज करें',
        current_annual_income: 'वार्षिक आय दर्ज करें (न्यूनतम 500000)',
        current_monthly_household_expenses: 'मासिक खर्च दर्ज करें (न्यूनतम 10000)',
        existing_term_insurance_coverage: 'क्या आपके पास मौजूदा टर्म इंश्योरेंस है? यदि हाँ, तो सभी पॉलिसियों के तहत अपनी वर्तमान कवरेज राशि दर्ज करें।',
        outstanding_lt_liabilities: 'अनुमानित कुल मूल्य दर्ज करें (यदि नहीं, तो 0 दर्ज करें)',
        insurance_for_liabilities: 'एक विकल्प चुनें',
        amount_of_cover_taken: 'कवरेज राशि दर्ज करें',
        est_funds_for_lt_responsibilities: 'अनुमанित कुल निधि दर्ज करें (यदि नहीं, तो 0 दर्ज करें)',
        investments_for_responsibilities: 'अनुमानित कुल मूल्य दर्ज करें (यदि नहीं, तो 0 दर्ज करें)',
        pf_balance: 'पीएफ बैलेंस दर्ज करें (यदि कर्मचारी नहीं, तो 0 दर्ज करें)',
        other_investments_ppf_nps: 'अनुमानित कुल मूल्य दर्ज करें (यदि नहीं, तो 0 दर्ज करें)',
        submit: 'जमा करें'

    },
    errors: {

      invalidMonthlyExpensesMax: "वार्षिक घरेलू खर्च वार्षिक आय से अधिक नहीं हो सकता।",
      invalidMonthlyExpensesMin: "मासिक घरेलू खर्च कम से कम ₹10,000 होना चाहिए।",
      invalidAnnualIncome: "वार्षिक आय कम से कम ₹5,00,000 होनी चाहिए।",
      invalidSpouseLifeExpectancy: "पति/पत्नी की जीवन प्रत्याशा 60 से 90 वर्ष के बीच होनी चाहिए।",
      invalidSpouseAge: "पति/पत्नी की आयु 20 से 55 वर्ष के बीच होनी चाहिए।",
      emailRequired: "ईमेल आवश्यक है।",
      emailInvalid: "अमान्य ईमेल प्रारूप।",
      invalidEmail: "कृपया एक मान्य ईमेल पता दर्ज करें।",
      invalidMobile: "कृपया 6-9 से शुरू होने वाला 10 अंकों का वैध मोबाइल नंबर दर्ज करें, जिसमें लगातार 4 समान अंक न हों।",
      languageRequired: "फॉर्म की भाषा आवश्यक है।",
      nameRequired: "नाम आवश्यक है।",
      mobileRequired: "मोबाइल नंबर आवश्यक है।",
      genderRequired: "लिंग आवश्यक है।",
      dobRequired: "जन्म तिथि आवश्यक है।",
      dateInvalid: "अमान्य तिथि प्रारूप।",
      cityRequired: "शहर आवश्यक है।",
      dependentsRequired: "निर्भर व्यक्तियों की संख्या आवश्यक है।",
      incomeRequired: "वार्षिक आय आवश्यक है।",
      expensesRequired: "मासिक घरेलू खर्च आवश्यक है।",
      coverageRequired: "मौजूदा कवरेज आवश्यक है।",
      liabilitiesRequired: "बकाया देनदारियाँ आवश्यक हैं।",
      insuranceLiabilitiesRequired: "कृपया बताएं कि क्या देनदारियों के लिए बीमा कवरेज लिया गया है।",
      coverAmountRequired: "बीमा लिया गया हो तो कवरेज राशि आवश्यक है।",
      responsibilitiesRequired: "जिम्मेदारियों के लिए अनुमानित निधि आवश्यक है।",
      investmentsRequired: "जिम्मेदारियों के लिए निवेश आवश्यक हैं।",
      pfRequired: "पीएफ बैलेंस आवश्यक है।",
      requiredCity: "कृपया अपने निवास का शहर चुनें।",
      requiredOtherCity: "कृपया अपना शहर निर्दिष्ट करें।",
      submitError: "फॉर्म सबमिशन विफल रहा।"
    
    },
    data: {


      soleEarnerOptions: [
        { value: 'Yes', label: 'हाँ' },
        { value: 'No', label: 'नहीं' }
      ],
      
      genderOptions: [
        { value: 'Male', label: 'पुरुष' },
        { value: 'Female', label: 'महिला' },
        { value: 'Other', label: 'अन्य' }
      ],
      maritalStatusOptions: [
        { value: 'Unmarried', label: 'अविवाहित' },
        { value: 'Married', label: 'विवाहित' },
        { value: 'Divorced', label: 'तलाकशुदा' },
        { value: 'Widowed', label: 'विधवा/विधुर' }
      ],
      cityOptions: [
        { value: 'Ahmedabad', label: 'अहमदाबाद' },
        { value: 'Bengaluru', label: 'बेंगलुरु' },
        { value: 'Chennai', label: 'चेन्नई' },
        { value: 'Delhi', label: 'दिल्ली' },
        { value: 'Hyderabad', label: 'हैदराबाद' },
        { value: 'Kolkata', label: 'कोलकाता' },
        { value: 'Mumbai', label: 'मुंबई' },
        { value: 'Pune', label: 'पुणे' },
        { value: 'Others', label: 'अन्य' },
      ],
      dependentsOptions: ['0','1','2','3','4','5','6'],
      termInsuranceCoverageOptions: ['0','5000000','10000000','15000000','20000000','30000000','other'],
      liabilitiesInsuranceCoverOptions: [
        { value: 'Yes', label: 'हाँ' },
        { value: 'No', label: 'नहीं' },
        { value: 'Partial', label: 'आंशिक कवरेज' }
      ]
    }
  }
};

export default TermInsuranceFormTranslations;
